import React, { Component } from 'react';
import { getAutoReplies, saveAutoReplyMessage } from '../../utility/autoReply';
import WaitForState from '../WaitForState';
import { addMessage } from '../../actions/messages';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import { hasPermission } from '../../utility/account';

/**
 * Component for showing conversation.
 *
 * @extends React.Component
 */
class AutoReplies extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      autoReplies: null,
      doneWorking: true,
      editAllowed: null,
    }
  }

  /**
   * Handle when an auto reply has been updated.
   */
  handleAutoReplyUpdate = (autoReplyId, e) => {
    if (!this.state.editAllowed) {
      return;
    }

    var autoRepliesC = this.state.autoReplies;
    autoRepliesC[autoReplyId].message = e.target.value;
    this.setState({autoReplies: autoRepliesC});

    // We don't want to trigger a request every time the user touches his
    // keyboard. Only trigger when he has not done so in half a second.
    if (this.saveTimeout === undefined) {
      this.saveTimeout = {};
    }
    if (this.saveTimeout[autoReplyId] !== undefined) {
      window.clearTimeout(this.saveTimeout[autoReplyId]);
    }
    this.saveTimeout[autoReplyId] = window.setTimeout(() => {
      this.setState({doneWorking: false});
      saveAutoReplyMessage(autoReplyId, this.state.autoReplies[autoReplyId].message, this.props.token, this.props.history, (response) => {
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under gemning af autosvar. Prøv venligst igen senere.', 'danger'));
        }
        this.setState({doneWorking: true});
      });
    }, 500);
  }

  /**
   * Fetch permission to edit auto replies.
   */
  fetchEditAllowedPermission = () => {
    hasPermission(this.props.user.id, "modify any auto reply", this.props.token, this.props.history, (allowed) => {
      this.setState({editAllowed: allowed});
    });
  }

  /**
   * Fetch auto replies.
   */
  fetchAutoReplies = () => {
    getAutoReplies(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af autosvar. Prøv venligst igen senere.', 'danger'));
      }

      response.json().then((data) => {
        var items = {};
        data.items.forEach((item) => {
          items[item.id] = item;
        });
        this.setState({autoReplies: items});
      });
    });
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchAutoReplies();
    this.fetchEditAllowedPermission();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="automessages" role="tabpanel" aria-labelledby="automessages">
        <div className="widget">
          <WaitForState keys={['doneWorking']} state={this.state} />
          <h3 className="section-heading">Autosvar</h3>
          <WaitForState state={this.state} keys={['autoReplies']}>
            {this.state.autoReplies && Object.keys(this.state.autoReplies).map((autoReplyId) => {
              var autoReply = this.state.autoReplies[autoReplyId];
              return (
              <div className="form-group" key={autoReply.id}>
                <label htmlFor={`autoreply-${autoReply.id}`}>{autoReply.name}</label>
                <textarea className="form-control" id={`autoreply-${autoReply.id}`} rows={3} value={autoReply.message} onChange={(e) => {this.handleAutoReplyUpdate(autoReply.id, e)}} disabled={this.state.editAllowed ? '' : 'disabled'} />
              </div>
            )})}
          </WaitForState>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(AutoReplies)));



// WEBPACK FOOTER //
// ./src/components/AutoReplies/index.js